import cn from 'classnames'
import React from 'react'
import { ReactSVG } from 'react-svg'

const WizardRadioButton = ({
  label,
  onClick,
  active,
  disabled,
  className,
}) => {
  const btnClassName = cn('wizard-radio-button', {
    'wizard-radio-button--active': active,
    [className]: className,
  })

  return (
    <button
      className={btnClassName}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="wizard-radio-button__check">
        <ReactSVG src="https://d16tr0byigrcd.cloudfront.net/hf/images/wizard/icon-wizard-selected.svg" />
      </div>
      {label}
    </button>
  )
}

export default WizardRadioButton
